import Vue from 'vue'
import Vuex from 'vuex'
import pkg from './../../package.json'

import {menu} from './menu/index.js'
import {configuration} from './configuration'
import {competition} from './competition'
import {security} from './security'

import axios from 'axios'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: true,  // process.env.NODE_ENV !== 'production',
  state: {
    pkg,
    vaconfig: {
      ServerURL: ''
    },
    device: {
      isMobile: false,
      isTablet: false
    },
    sidebar: {
      opened: false,
      hidden: false
    }
  },
  mutations: {
    TOGGLE_DEVICE (state, device) {
      state.device.isMobile = device === 'mobile'
      state.device.isTablet = device === 'tablet'
    },
    TOGGLE_SIDEBAR (state, opened) {
      if (state.device.isMobile) {
        state.sidebar.opened = opened
      } else {
        state.sidebar.opened = true
      }
    },
    UpdateVaConfig (state, config) {
      state.vaconfig = config
    }
  },
  actions: {
    toggleSidebar: ({commit}, opened) => commit('TOGGLE_SIDEBAR', opened),
    toggleDevice: ({commit}, device) => commit('TOGGLE_DEVICE', device),
    LoadVaConfig (context) {
      return new Promise((resolve) => {
        axios.get('./vaconfig.json').then((res) => {
          if (res != null) {
            let url = res.data.ServerURL
            if (url.includes('[host]')) {
              res.data.ServerURL = url.replace('[host]', document.location.protocol + '//' + document.location.host)
            }
            context.commit('UpdateVaConfig', res.data)
            resolve()
          }
        }).catch(() => {
          console.log('Error loading Config..., using default 127.0.0.1/vapi/')
          context.commit('UpdateVaConfig', {ServerURL: document.location.protocol + '//' + document.location.host.replace(':8080', '') + '/vapi/'})
          resolve()
        })
      })
    }
  },
  getters: {
    pkg: state => state.pkg,
    device: state => state.device,
    sidebar: state => state.sidebar,
    componententry: state => {
      return state.menu.items.filter(c => c.meta && c.meta.label === 'Components')[0]
    },
    vaconfig: state => state.vaconfig
  },
  modules: {
    menu,
    configuration,
    security,
    competition
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js